import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { styled, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { INSTANCE_STATE } from '../../../apis/constants';

const StyledStatus = styled(FiberManualRecordIcon)(({ color, theme }) => ({
  color: color,
  fontSize: '1rem',
  paddingLeft: theme.spacing(1),
}));

// Component
const Status = ({ instanceState, solrRunning }) => {
  const { t } = useTranslation();

  const theme = useTheme();

  const getState = (instanceState, solrRunning) => {
    if (instanceState === INSTANCE_STATE.PENDING) {
      return {
        color: theme.palette.info.light,
        blinking: true,
        message: t('instancePending', { ns: 'tooltips' }),
      };
    } else if (instanceState === INSTANCE_STATE.FAILED) {
      return {
        color: theme.palette.error.light,
        blinking: false,
        message: t('instanceFailed', { ns: 'tooltips' }),
      };
    } else if (instanceState === INSTANCE_STATE.TERMINATING) {
      return {
        color: theme.palette.warning.light,
        blinking: false,
        message: t('instanceTerminating', { ns: 'tooltips' }),
      };
    }

    if (solrRunning) {
      return {
        color: theme.palette.success.light,
        blinking: instanceState === INSTANCE_STATE.PENDING,
        message: t('instanceRunning', { ns: 'tooltips' }),
      };
    } else {
      return {
        color: '#777',
        blinking: instanceState === INSTANCE_STATE.PENDING,
        message: t('instanceStopped', { ns: 'tooltips' }),
      };
    }
  };

  const { color, blinking, message } = getState(instanceState, solrRunning);

  return (
    <Tooltip title={message} placement="top">
      <StyledStatus
        data-testid="status"
        color={color}
        sx={
          blinking && {
            '@keyframes blinker': {
              from: { opacity: 1 },
              to: { opacity: 0 },
            },
            animationName: 'blinker',
            animationDuration: '1.5s',
            animationTimingFunction: 'linear',
            animationIterationCount: 'infinite',
          }
        }
      />
    </Tooltip>
  );
};

Status.propTypes = {
  instanceState: PropTypes.string.isRequired,
  solrRunning: PropTypes.bool,
};

export default Status;
